import { AxiosResponse } from 'axios';
import apiClient from '../../../../shared/infrastructure/api/client';
import { PatientChatRequest, PatientChatResponse } from '../../domain/PatientChat';

export const PatientChatApiService = {
  sendMessage: (
    patientId: string,
    payload: PatientChatRequest,
  ): Promise<AxiosResponse<PatientChatResponse>> =>
    apiClient.post(`/patients/${patientId}/chat`, payload),
};
